import { isBrowser, universalBtoa } from '@web/js';
import { useEffect } from 'react';
import { useDomestikaContext } from '@web/react-context';

const findOrCreateStyleElement = (doc, id) => {
  const existentLink = doc.getElementById(id);
  if (existentLink) return existentLink;
  const styleElement = doc.createElement('style');
  const head = doc.head || doc.getElementsByTagName('head')[0];
  styleElement.type = 'text/css';
  head == null ? void 0 : head.appendChild(styleElement);
  return styleElement;
};

const setDangerouslyStyle = (css, id, doc) => {
  if (!isBrowser) return null;
  const styleElement = findOrCreateStyleElement(doc, id);
  styleElement.appendChild(document.createTextNode(css));
  styleElement.id = id;
  return {
    doc,
    tag: styleElement
  };
};

const useDangerouslyStyle = function (css, _temp) {
  let {
    includeIframes = false
  } = _temp === void 0 ? {} : _temp;
  const context = useDomestikaContext();
  const id = universalBtoa(css.slice(0, 16));

  if (context != null && context.dangerousStyles) {
    context.dangerousStyles[id] = css;
  }

  useEffect(() => {
    const iframes = includeIframes ? Array.from(document.querySelectorAll('iframe')).map(iframe => {
      return {
        doc: iframe.contentDocument,
        win: iframe.contentWindow
      };
    }) : [];
    const pages = [{
      win: window,
      doc: document
    }, ...iframes];
    const styles = pages.filter(page => page.doc && page.win).map(page => setDangerouslyStyle(css, id, page.doc, page.win));
    return () => styles.forEach(style => {
      const [head] = Array.from(style.doc.getElementsByTagName('head'));

      try {
        (head == null ? void 0 : head.removeChild) && head.removeChild(style.tag);
      } catch (e) {}
    });
  }, []);
};

export default useDangerouslyStyle;